import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { UserListDownloadStart, UserListInitialState, UserListLoad } from './user-list.actions';
import { UserListState, UserListStateModel } from './user-list.state';
import { UserListSearchCriteria } from '../models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';
import { MatDialogRef } from '@angular/material/dialog';
import { ExportDialogComponent } from '../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class UserListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<UserListStateModel> = this.store.select(UserListState.getState);
  loaded$: Observable<boolean> = this.store.select(UserListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Users)
      .subscribe((searchCriteria: UserListSearchCriteria) => {
        this.store.dispatch(new UserListLoad(searchCriteria));
      });
  }

  startExportToFile(name: string, dialogRef: MatDialogRef<ExportDialogComponent>, navigationNeeded: boolean): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Users)
      .subscribe((searchItem: UserListSearchCriteria) => {
        const { size: _size, page: _page, ...filterView } = searchItem;
        this.store.dispatch(
          new UserListDownloadStart({
            name,
            filterView,
            dialogRef,
            navigationNeeded,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new UserListInitialState());
  }
}
